import { HeightMapToken } from 'antd/es/theme/interface'

export const HeightMap: HeightMapToken = {
  controlHeightXS: 16,
  controlHeightSM: 24,
  controlHeightLG: 40,
}
